(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-media-six-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  const root = document.currentScript.closest('.six-grid-gallery');
  if(!root) return;
  const dialog = root.querySelector('[data-dialog]');
  if(!dialog) return;

  root.addEventListener('click', (e)=>{
    const btn = e.target.closest('[data-modal-src]');
    if(!btn) return;
    const html = btn.getAttribute('data-modal-src');
    const stage = dialog.querySelector('[data-stage]');
    stage.innerHTML = html;
    dialog.showModal();
  });

  dialog?.addEventListener('click', (e)=>{
    if(e.target.hasAttribute('data-close') || e.target === dialog) dialog.close();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
